// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"e09b327c","42":"948eb7de","191":"31a14da4","477":"f7fe8055","569":"5992c253","836":"c7703d99","931":"1212b524"}[chunkId] + ".chunk.js";
};